<template>
    <div>
        <button
            @click="nextSlide"
            class="inline-flex justify-center items-center px-6 py-2 mt-6 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
        >
            {{ text }}
            <component
                :is="text === 'Repeat' ? RefreshIcon : ArrowRightIcon"
                class="h-5 w-5 ml-2"
            />
        </button>
    </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { ArrowRightIcon, RefreshIcon } from "@heroicons/vue/solid";
import type { AppEmitter } from "../../emitter";

defineProps<{
    text?: string;
}>();

const emitter = inject<AppEmitter>("mitt")!;

function nextSlide() {
    emitter.emit("nextSlide");
}
</script>
